import { Injectable, OnDestroy } from "@angular/core";
import { Actions, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";
import { DeviceActions } from "../actions";

@Injectable()
export class DeviceFacade implements OnDestroy {
  private readonly _devices$ = new ReplaySubject<MediaDeviceInfo[]>(1);
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store
  ) {
    this.actions$
      .pipe(
        ofType(DeviceActions.loadDevicesSuccess),
        tap((_) => this._devices$.next(_.devices)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get devices$() {
    return this._devices$.asObservable();
  }

  loadDevices() {
    return this.store.dispatch(DeviceActions.loadDevices());
  }
}
